import Vue from 'vue'
import VueRouter from 'vue-router'
import PromoHome from '@/views/PromoSite/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    props: true,
    component: PromoHome,
    meta: { label: 'Home', stickyNav: false }
  },
  {
    path: '/features',
    name: 'FeaturesView',
    props: true,
    component: () => import('@/views/PromoSite/FeaturesView.vue'),
    meta: { label: 'Features', stickyNav: true }
  },
  {
    path: '/activities',
    name: 'FeaturesView',
    props: true,
    component: () => import('@/views/PromoSite/FeaturesView.vue'),
    meta: { label: 'Activities', stickyNav: true }
  },
  {
    path: '/activities/activity-demo/:playKey',
    name: 'ActivityDetailView',
    props: true,
    component: () => import('@/views/PromoSite/ActivityDetailView.vue'),
    meta: { label: 'Activity', stickyNav: true }
  },
  {
    path: '/plans',
    name: 'PlansView',
    props: true,
    component: () => import('@/views/PromoSite/PlansView.vue'),
    meta: { label: 'Plans', stickyNav: true }
  },
  {
    path: '/plans/:tag',
    name: 'BernellPlansRedirect',
    props: true,
    component: () => import('@/views/PromoSite/BernellPlansRedirect.vue'),
    meta: { label: 'Plans', stickyNav: true }
  },
  {
    path: '/about',
    name: 'AboutView',
    props: true,
    component: () => import('@/views/PromoSite/AboutView.vue'),
    meta: { label: 'About', stickyNav: true }
  },
  {
    path: '/data',
    name: 'DataView',
    props: true,
    component: () => import('@/views/PromoSite/DataView.vue'),
    meta: { label: 'Data', stickyNav: true }
  },
  {
    path: '/partners/:tag',
    name: 'PartnerView',
    props: true,
    component: () => import('@/views/PromoSite/PartnerView.vue'),
    meta: { label: 'Partner', stickyNav: true }
  },
  {
    path: '/mp-clinics',
    name: 'MaintenanceClinicsView',
    props: true,
    component: () => import('@/views/PromoSite/MaintenanceClinicsView.vue'),
    meta: { label: '', stickyNav: true }
  },
  {
    path: '/mp',
    name: 'MaintenancePatientsView',
    props: true,
    component: () => import('@/views/PromoSite/MaintenancePatientsView.vue'),
    meta: { label: '', stickyNav: true }
  },
  {
    path: '/home-program',
    name: 'HomeProgramView',
    props: true,
    component: () => import('@/views/PromoSite/HomeProgramView.vue'),
    meta: { label: 'Home Program', stickyNav: true }
  },
  {
    path: '/brain-rehab',
    name: 'BrainRehab',
    props: true,
    component: () => import('@/views/PromoSite/BrainRehab.vue'),
    meta: { label: 'Brain Rehab', stickyNav: true }
  },
  {
    path: '/brain-rehab-home',
    name: 'BrainRehabHome',
    props: true,
    component: () => import('@/views/PromoSite/BrainRehabHome.vue'),
    meta: { label: 'Brain Rehab at Home', stickyNav: true }
  },
  {
    path: '/brain-rehab-registration',
    name: 'BrainRehabRegistrationView',
    props: true,
    component: () => import('@/views/PromoSite/BrainRehabRegistrationView.vue'),
    meta: { label: 'Brain Rehab Trial', stickyNav: true }
  },
  {
    path: '/todos',
    name: 'TodosView',
    props: true,
    component: () => import('@/views/PromoSite/TodosView.vue'),
    meta: { label: 'Todos', stickyNav: true }
  },
  {
    path: '/nora',
    name: 'NoraView',
    props: true,
    component: () => import('@/views/PromoSite/NoraView.vue'),
    meta: { label: 'Nora', stickyNav: true }
  },
  {
    path: '/nora-thank-you',
    name: 'NoraThankYouView',
    props: true,
    component: () => import('@/views/PromoSite/NoraThankYouView.vue'),
    meta: { label: 'Thank You', stickyNav: true }
  },
  {
    path: '/worksheets',
    component: () => import('@/views/PromoSite/NoraView.vue'),
    meta: { label: 'Worksheets', stickyNav: true }
  },
  {
    path: '/worksheets-thank-you',
    component: () => import('@/views/PromoSite/NoraThankYouView.vue'),
    meta: { label: 'Thank You', stickyNav: true }
  },
  {
    path: '/bookstore',
    name: 'StoreView',
    props: true,
    component: () => import('@/views/PromoSite/StoreView.vue'),
    meta: { label: 'Bookstore', stickyNav: true }
  },
  {
    path: '/bookstore/see-and-say',
    name: 'BookSeeAndSayView',
    props: true,
    component: () => import('@/views/PromoSite/BookSeeAndSayView.vue'),
    meta: { label: 'Book', stickyNav: true }
  },
  {
    path: '/bookstore/see-and-say-flipbook',
    name: 'SeeAndSayFlipbookView',
    props: true,
    component: () => import('@/views/PromoSite/SeeAndSayFlipbookView.vue'),
    meta: { label: 'Flipbooks', stickyNav: true }
  },
  {
    path: '/bookstore/ippra',
    name: 'BookIppraView',
    props: true,
    component: () => import('@/views/PromoSite/BookIppraView.vue'),
    meta: { label: 'Book', stickyNav: true }
  },
  {
    path: '/contact',
    name: 'ContactView',
    props: true,
    component: () => import('@/views/PromoSite/ContactView.vue'),
    meta: { label: 'Contact', stickyNav: true }
  },
  {
    path: '/free-trial',
    name: 'BrochureFreeTrial',
    props: true,
    component: () => import('@/views/PromoSite/FreeTrialView.vue'),
    meta: { label: 'Free Trial', stickyNav: true }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    props: true,
    component: () => import('@/views/PrivacyPolicy.vue'),
    meta: { label: 'Privacy Policy', stickyNav: true }
  },
  {
    path: '/frequently-asked-questions',
    name: 'FaqView',
    props: true,
    component: () => import('@/views/FaqView.vue'),
    meta: { label: 'FAQ', stickyNav: true }
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    props: true,
    component: () => import('@/views/TermsAndConditions.vue'),
    meta: { label: 'Terms and Conditions', stickyNav: true }
  },
  // Login redirects to the app (play.ourvisualbrain.com in prod, devplay in dev)
  {
    path: '/login',
    name: 'Login',
    beforeEnter () {
      const appUrl = process.env.VUE_APP_LOGIN_URL || 'https://play.ourvisualbrain.com/login'
      window.location.href = appUrl
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
